<script setup lang="ts">
import { computed } from "vue";

import type { BaseLabelProps } from "@/shared/components/temparary/components/base/label/BaseLabelModel";

const props = defineProps<BaseLabelProps>();

const conditionClass = computed(() => {
    return {
        "after:content-['_*'] after:text-primary-red": props.required,
    };
});
</script>

<template>
    <label
        :for="props.name"
        class="flex shrink-0 text-base text-primary-black font-pretended-500 xl:w-[15.6rem] xl:min-w-[15.6rem] w-[9rem] min-w-[9rem]"
        :class="conditionClass"
        >{{ props.label || "" }}</label
    >
</template>

<style scoped></style>
